"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenericAlert = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("../button/Button");
var _Icon = require("../svg/Icon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var maxWidth = 768; // above medium device
var minWidth = 320; // small device
var GenericAlert = /*#__PURE__*/function (_React$Component) {
  _inherits(GenericAlert, _React$Component);
  var _super = _createSuper(GenericAlert);
  function GenericAlert(props) {
    var _this;
    _classCallCheck(this, GenericAlert);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "closeButtonClick", function (event) {
      if (_this.props.onCloseClick) {
        _this.props.onCloseClick(event);
      }
      _this.setState({
        hidden: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onClickId", function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event.currentTarget.id);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getRenderedItems", function () {
      var MAX_ITEMS = _this.props.maxItemToDisplay;
      var totalEnqList = _this.props.displayList;
      if (_this.state.isOpen) {
        return totalEnqList;
      }
      return totalEnqList.slice(0, MAX_ITEMS);
    });
    _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      _this.setState({
        isOpen: !_this.state.isOpen
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderAlertWarning", function () {
      return /*#__PURE__*/_react.default.createElement("div", null, _this.props.name && !_this.state.hidden && /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-alert-box tl-ui tl-generic-warning ".concat(_this.state.width > minWidth ? 'generic-alert-large-warning' : 'generic-alert-small', "  ").concat(_this.props.showBackground ? '' : 'hide-background'),
        tabIndex: 0,
        style: _this.props.customStyle
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _this.props.showBackground ? 'tl-container-wrapper' : 'tl-container-wrapper-2'
      }, _this.props.closeButton && _this.renderCloseButton(), /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-icon-wrapper"
      }, _this.props.header ? /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-generic-header"
      }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
        name: _this.props.icon ? _this.props.icon : 'icon-system-alert-small',
        className: _this.props.className ? _this.props.className : 'tl-svg-info-icon'
      }), _this.props.header) : /*#__PURE__*/_react.default.createElement("div", {
        className: _this.state.width > minWidth ? 'tl-generic-body-large' : 'tl-generic-body-small'
      }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
        name: _this.props.icon ? _this.props.icon : 'icon-system-alert-small',
        className: _this.props.className ? _this.props.className : 'tl-svg-info-icon'
      }), _this.props.description)), _this.props.header && /*#__PURE__*/_react.default.createElement("div", {
        className: _this.state.width > minWidth ? 'tl-generic-body-large' : 'tl-generic-body-small'
      }, _this.props.description), _this.props.button && !_this.props.linkLabel && /*#__PURE__*/_react.default.createElement("div", {
        className: "alert-primary-warning"
      }, /*#__PURE__*/_react.default.createElement("span", null), /*#__PURE__*/_react.default.createElement("span", null, _this.props.onClick && /*#__PURE__*/_react.default.createElement(_Button.Button, {
        variant: "primary",
        state: "warning",
        size: "medium",
        className: "demo",
        label: _this.props.button || '',
        onClick: _this.props.onClick
      }))), _this.props.linkLabel && !_this.props.button && /*#__PURE__*/_react.default.createElement("div", {
        className: "alert-primary-active"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "hyperLink",
        tabIndex: 0
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "hyperLink",
        onClick: _this.props.onLinkClick,
        href: _this.props.link
      }, _this.props.linkLabel))))));
    });
    _defineProperty(_assertThisInitialized(_this), "renderAlertPrimary", function () {
      return !_this.state.hidden && /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-alert-box tl-ui ".concat(_this.state.width > minWidth ? 'generic-alert-large' : 'generic-alert-small', "  ").concat(_this.props.showBackground ? '' : 'hide-background'),
        tabIndex: 0,
        style: _this.props.customStyle
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _this.props.showBackground ? 'tl-container-wrapper' : 'tl-container-wrapper-2'
      }, _this.props.closeButton && _this.renderCloseButton(), /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-icon-wrapper"
      }, _this.props.header ? /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-generic-header"
      }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
        screenReaderContent: "Information",
        name: _this.props.icon ? _this.props.icon : 'icon-system-info-small',
        className: _this.props.className ? _this.props.className : 'tl-svg-info-icon'
      }), _this.props.header) : /*#__PURE__*/_react.default.createElement("div", {
        className: _this.state.width > minWidth ? 'tl-generic-body-large' : 'tl-generic-body-small'
      }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
        name: _this.props.icon ? _this.props.icon : 'icon-system-info-small',
        className: _this.props.className ? _this.props.className : 'tl-svg-info-icon'
      }), _this.props.description)), _this.props.header && /*#__PURE__*/_react.default.createElement("div", {
        className: _this.state.width > minWidth ? 'tl-generic-body-large' : 'tl-generic-body-small',
        style: {
          paddingLeft: _this.props.displayList ? '30px' : ""
        }
      }, _this.props.description, _this.props.displayList && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0", _this.props.isMobileView && /*#__PURE__*/_react.default.createElement("br", null), _this.getRenderedItems().map(function (item, id) {
        return id === _this.props.displayList.length - 1 ? /*#__PURE__*/_react.default.createElement("div", {
          onClick: _this.onClickId,
          id: item,
          className: "hyperLink-list"
        }, item) : /*#__PURE__*/_react.default.createElement("div", {
          onClick: _this.onClickId,
          id: item,
          className: "hyperLink-list"
        }, id + 2 > _this.props.maxItemToDisplay && !_this.state.isOpen ? item.slice(0, _this.props.sliceAt) : item, ",", /*#__PURE__*/_react.default.createElement("span", {
          className: "no-underline"
        }, "\xA0"));
      }), _this.props.displayList.length > _this.props.maxItemToDisplay && /*#__PURE__*/_react.default.createElement("a", {
        onClick: _this.toggle,
        className: "showMore"
      }, _this.state.isOpen ? '' : '...', /*#__PURE__*/_react.default.createElement("span", {
        style: {
          paddingLeft: '10px'
        }
      }, _this.state.isOpen ? 'Show less' : 'Show more')))), _this.props.button && !_this.props.linkLabel && /*#__PURE__*/_react.default.createElement("div", {
        className: "alert-primary-active"
      }, /*#__PURE__*/_react.default.createElement("span", {
        tabIndex: 0
      }), /*#__PURE__*/_react.default.createElement("span", null, _this.props.onClick && /*#__PURE__*/_react.default.createElement(_Button.Button, {
        variant: "primary",
        size: "medium",
        className: "button-background-color",
        label: _this.props.button || '',
        onClick: _this.props.onClick
      }))), _this.props.linkLabel && !_this.props.button && /*#__PURE__*/_react.default.createElement("div", {
        className: "alert-primary-active"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "hyperLink",
        tabIndex: 0
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "hyperLink",
        onClick: _this.props.onLinkClick,
        href: _this.props.link
      }, _this.props.linkLabel)))));
    });
    _defineProperty(_assertThisInitialized(_this), "renderAlertSuccess", function () {
      return !_this.state.hidden && /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-alert-box tl-ui tl-generic-success ".concat(_this.state.width > minWidth ? 'generic-alert-large-success' : 'generic-alert-small', "  ").concat(_this.props.showBackground ? '' : 'hide-background'),
        tabIndex: 0,
        style: _this.props.customStyle
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _this.props.showBackground ? 'tl-container-wrapper' : 'tl-container-wrapper-2'
      }, _this.props.closeButton && _this.renderCloseButton(), /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-icon-wrapper"
      }, _this.props.header ? /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-generic-header"
      }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
        name: _this.props.icon ? _this.props.icon : 'icon-system-tick-circle',
        className: _this.props.className ? _this.props.className : 'tl-svg-success-icon'
      }), _this.props.header) : /*#__PURE__*/_react.default.createElement("div", {
        className: _this.state.width > minWidth ? 'tl-generic-body-large' : 'tl-generic-body-small'
      }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
        name: _this.props.icon ? _this.props.icon : 'icon-system-tick-circle',
        className: _this.props.className ? _this.props.className : 'tl-svg-success-icon'
      }), _this.props.description)), _this.props.header && /*#__PURE__*/_react.default.createElement("div", {
        className: _this.state.width > minWidth ? 'tl-generic-body-large' : 'tl-generic-body-small'
      }, _this.props.description), _this.props.button && !_this.props.linkLabel && /*#__PURE__*/_react.default.createElement("div", {
        className: "alert-primary-active"
      }, /*#__PURE__*/_react.default.createElement("span", {
        tabIndex: 0
      }), /*#__PURE__*/_react.default.createElement("span", null, _this.props.onClick && /*#__PURE__*/_react.default.createElement(_Button.Button, {
        variant: "primary",
        size: "medium",
        className: "button-background-color",
        label: _this.props.button || '',
        onClick: _this.props.onClick
      }))), _this.props.linkLabel && !_this.props.button && /*#__PURE__*/_react.default.createElement("div", {
        className: "alert-primary-active"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "hyperLink",
        tabIndex: 0
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "hyperLink",
        onClick: _this.props.onLinkClick,
        href: _this.props.link
      }, _this.props.linkLabel)))));
    });
    _this.state = {
      width: minWidth,
      hidden: false,
      isOpen: false
    };
    return _this;
  }
  _createClass(GenericAlert, [{
    key: "updateDimensions",
    value: function updateDimensions() {
      if (window.innerWidth < maxWidth) {
        this.setState({
          width: minWidth
        });
      } else {
        this.setState({
          width: window.innerWidth
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateDimensions();
      window.addEventListener('resize', this.updateDimensions.bind(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions.bind(this));
    }
  }, {
    key: "renderCloseButton",
    value: function renderCloseButton() {
      return /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "tl-alert-close-button tl-generic-button",
        "aria-label": "Close Alert",
        onClick: this.closeButtonClick
      }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
        name: "icon-navigation-close",
        title: "Close",
        className: "tl-alert-close-icon"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$name = this.props.name,
        name = _this$props$name === void 0 ? 'primary' : _this$props$name;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-generic-alert-container"
      }, name && name.includes('primary') && this.renderAlertPrimary(), name && name.includes('warning') && this.renderAlertWarning(), name && name.includes('success') && this.renderAlertSuccess());
    }
  }]);
  return GenericAlert;
}(_react.default.Component);
exports.GenericAlert = GenericAlert;
_defineProperty(GenericAlert, "defaultProps", {
  showBackground: true
});